import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { SearchInput, SelectAreaGroup } from 'components';
import { Typography, TextField, MenuItem } from '@material-ui/core';

//import { areas, groups } from 'common/datas';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  row1: {
    width: '240px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(6),
    '& > *': {
      marginLeft: theme.spacing(0),
      margin: theme.spacing(1),
    },
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const CampaignToolbar = props => {
  //const { className, ...rest } = props;

  const { 
    className, 
    areas,
    groups,
    onClickSearch,
    ...rest
 } = props;

  const classes = useStyles();

  const [searchItemName, setSearchItemName] = useState('');

  const [selectedArea, setSelectedArea] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');

  const [areaGroups, setAreaGroups] = useState([]);

  const handleChangeArea = (e) => {
    let newAreaGroups = groups.filter(group => group.area === e.target.value);
    //console.log('new groups ->');
    //console.log(newAreaGroups);
    setAreaGroups(newAreaGroups);
    setSelectedGroup('');
    setSelectedArea(e.target.value)
  }

  // useEffect(() => {
  //   setFindItemName('');
  // }, [category]);


  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          캠패인 명
        </Typography>
        <SearchInput
          className={classes.searchInput}
          placeholder=""
          value={searchItemName}
          onChange={e => setSearchItemName(e.target.value)}
        />
       <Button
        color="primary"
        variant="contained"
        onClick={ () => onClickSearch(searchItemName, selectedArea, selectedGroup) }
       >
         조회
       </Button>
       
      </div>

      <SelectAreaGroup 
        areas={areas}
        groups={areaGroups}
        valueArea={selectedArea}
        onChangeArea={handleChangeArea}
        valueGroup={selectedGroup}
        onChangeGroup={e => setSelectedGroup(e.target.value)}
        />
    </div>
  );
};

CampaignToolbar.propTypes = {
  className: PropTypes.string
};

export default CampaignToolbar;
